import React, { useEffect, useState } from 'react';

import { useSnackbar } from 'notistack';

import { CONFIGS } from '../../utilities/Configs';
import { ConstructFetchBody, FormatDate, FormatNumber, FormatTime, UrlQueryParam } from '../../utilities/Helpers';
import { TowerPhotoRequest } from '../../utilities/Types';

import { Avatar, Grid, MenuItem, TextField } from '@material-ui/core';
import { ArrowDownward as IconArrowDown, ArrowUpward as IconArrowUp } from '@material-ui/icons';

import { Loading } from '../../sharedcomponents/Loading';

import { RequestManage } from './RequestManage';

import './Init.css';

export const Init = () => {
	const [towerPhotoRequests, setTowerPhotoRequests] = useState<undefined | Array<TowerPhotoRequest['Location']['Table'][number]>>(undefined);
	const [sort, setSort] = useState<{ column: string, order: 'asc' | 'desc', status: number, limit: number }>({ column: 'LocationName', order: 'asc', status: 15, limit: 100 });
	const [selectedTowerPhotoRequest, setSelectedTowerPhotoRequest] = useState<undefined | TowerPhotoRequest['Location']['Table'][number]>(undefined);

	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		fetchTowerPhotoRequests();
	}, [sort]);

	const fetchTowerPhotoRequests = () => {
		fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.TOWER_PHOTO_REQUESTS_GET, [UrlQueryParam('token'), UrlQueryParam('serviceCenterId'), sort.status, sort.limit, sort.column, sort.order])).then(
			(_response) => _response.json()
		).then(
			(_response) => setTowerPhotoRequests(_response['result'])
		).catch(
			() => enqueueSnackbar('An unexpected error has occurred. Please try again later. If problem persists, please contact support.', { variant: 'error' })
		);
	};

	const handleReject = () => {
		setSelectedTowerPhotoRequest(undefined);

		fetchTowerPhotoRequests();
	};

	const handleApprove = () => {
		setSelectedTowerPhotoRequest(undefined);

		fetchTowerPhotoRequests();
	};
	
	return (
		<div className="towerphotos">
			{
				towerPhotoRequests === undefined ? (
					<Loading />
				) : (
					<Grid container>
						<Grid item xs={12} md={3} className="sidebar">
							<p className="heading">AI - Tower Faucet Photos</p>
							{
								towerPhotoRequests.length > 0 && (
									<>
										<TextField
											value={sort.column}
											label="Sort by"
											select
											InputLabelProps={{
												shrink: true
											}}
											variant="outlined"
											margin="dense"
											fullWidth
											onChange={(_event) => setSort({ ...sort, ...{ column: _event.target.value } })}
										>
											<MenuItem value="LocationName">Location</MenuItem>
											<MenuItem value="CreatedOn">Date Created</MenuItem>
										</TextField>
										<div className="row spread">
											<p className="mute pointer" onClick={() => setSort({ ...sort, ...{ status: (sort.status === 15 ? 9 : 15) }})}>{sort.status === 15 ? 'Show Open & Partially Completed' : 'Show All'}</p>
											<div className="center">
												{
													sort.order === 'asc' ? (
														<IconArrowDown fontSize="small" className="mute" />
													) : (
														<IconArrowUp fontSize="small" className="mute" />
													)
												}
												<p className="mute pointer" onClick={() => setSort({ ...sort, ...{ order: (sort.order === 'asc' ? 'desc' : 'asc') } })}>Sort</p>
											</div>
										</div>
										<p className="bold">Requests ({FormatNumber(towerPhotoRequests.length)})</p>
										<div className="list">
											{
												towerPhotoRequests.map(
													(_towerPhotoRequest, _i) => (
														<div key={_i} className={'row pointer' + (_towerPhotoRequest['twrid'] === selectedTowerPhotoRequest?.['twrid'] ? ' active' : '')} onClick={() => setSelectedTowerPhotoRequest(_towerPhotoRequest)}>
															<Avatar src={CONFIGS.STORAGE.IMAGE_LOCATION_URL.replace('{ID}', _towerPhotoRequest['LocationGuid'])}>{_towerPhotoRequest['LocationName'].substr(0, 1)}</Avatar>
															<div className="stretch">
																<div className="row spread">
																	<p className="small mute">{_towerPhotoRequest['FaucetCount']} faucets</p>
																	{
																		_towerPhotoRequest['createdOn'] !== null && (
																			FormatDate(new Date(_towerPhotoRequest['createdOn'])) === FormatDate(new Date()) ? (
																				<p className="small mute">{FormatTime(new Date(_towerPhotoRequest['createdOn']))}</p>
																			) : (
																				<p className="small mute">{FormatDate(new Date(_towerPhotoRequest['createdOn']))}, {FormatTime(new Date(_towerPhotoRequest['createdOn']))}</p>
																			)
																		)
																	}
																</div>
																<div className="row spread">
																	<p className="bold">{_towerPhotoRequest['LocationName']}</p>
																	{
																		_towerPhotoRequest['status'] === 2 ? (
																			<div className="center">
																				<div style={{ width: 8, height: 8, borderRadius: 4, backgroundColor: 'green' }} />
																			</div>
																		) :
																		_towerPhotoRequest['status'] === 4 ? (
																			<div className="center">
																				<div style={{ width: 8, height: 8, borderRadius: 4, backgroundColor: 'red' }} />
																			</div>
																		) :
																		_towerPhotoRequest['status'] === 8 && (
																			<div className="center">
																				<div style={{ width: 8, height: 8, borderRadius: 4, backgroundColor: 'orange' }} />
																			</div>
																		)
																	}
																</div>
																<p className="small mute">{_towerPhotoRequest['address']}, {_towerPhotoRequest['citystatezip']}</p>
															</div>
														</div>
													)
												)
											}
										</div>
									</>
								)
							}
						</Grid>
						<Grid item xs={12} md={9} className="sidebar">
							{
								selectedTowerPhotoRequest === undefined ? (
									<div className="main center">
										<p>No tower faucet photo request selected.</p>
									</div>
								) : (
									<RequestManage towerPhotoRequest={selectedTowerPhotoRequest} onReject={handleReject} onApprove={handleApprove} onClose={() => setSelectedTowerPhotoRequest(undefined)} />
								)
							}
						</Grid>
					</Grid>
				)
			}
		</div>
	);
};